/**
 * Fetches the unread message count for a user.
 * @param accessToken - The access token for the user.
 * @param userSSOId - The SSO ID of the user.
 * @returns The unread message count.
 */
const fetchUnreadMessageCount = async (
  accessToken: string,
  userSSOId: string,
): Promise<number> => {
  if (!accessToken || !userSSOId) {
    throw new Error("Access token and user SSO ID are required");
  }

  try {
    const response = await fetch(
      `/v1/messages/user/threads/count?is_read=false&to=${userSSOId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch unread message count with status: ${response.status}`,
      );
    }

    const data = await response.json();
    return data.thread_count || 0;
  } catch (error) {
    throw new Error("Failed to fetch unread message count", { cause: error });
  }
};

export { fetchUnreadMessageCount };
